import InputAdmin from "./InputAdmin";
import { useState, useEffect } from "react";

export default function VerificationCard({ usersData }) {
  const [imageOpen, setImageOpen] = useState(false);
  const [imageSrc, setImageSrc] = useState(null);
  return (
    <>
      <div className="w-full max-w-3xl rounded-2xl p-4 flex flex-col gap-6 bg-zi-bg2-light dark:bg-zi-bg2-dark">
        <div className="w-full flex items-center justify-between">
          <span className="font-medium text-xl text-zi-text-light dark:text-zi-text-dark">
            تأیید دومرحله‌ای و احراز هویت
          </span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-6">
          <InputAdmin
            label="تأیید دومرحله‌ای"
            isStatus={true}
            status={usersData?.two_fa_enabled ? "done" : "none"}
          />
          <InputAdmin
            label="احراز هویت"
            isStatus={true}
            status={usersData?.kyc_status || ""}
          />
          {usersData?.kyc_status === "done" && (
            <>
              <InputAdmin
                label="فایل مدرک شناسایی"
                isFile={true}
                onClick={() => {
                  const imageSrc = usersData?.kyc?.find(
                    (k) => (k.kyc_type = "identity")
                  )?.documents[0]?.file;
                  setImageOpen(true);
                  setImageSrc(imageSrc);
                }}
              />
              <InputAdmin
                label="فایل تصویر سلفی"
                isFile={true}
                onClick={() => {
                  const imageSrc = usersData?.kyc?.find(
                    (k) => (k.kyc_type = "identity_with_selfie")
                  )?.documents[0]?.file;
                  setImageOpen(true);
                  setImageSrc(imageSrc);
                }}
              />
            </>
          )}
        </div>
      </div>
      {imageOpen && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/60"
          onClick={() => setImageOpen(false)} // 👈 click outside closes
        >
          {imageSrc && imageSrc.toLowerCase().endsWith(".pdf") === true ? (
            <iframe
              src={imageSrc}
              alt="preview"
              className="max-w-[90%] max-h-[90%] aspect-[9/16]"
              onClick={(e) => e.stopPropagation()}
            />
          ) : (
            <img
              src={imageSrc}
              alt="preview"
              className="max-w-[90%] max-h-[90%]"
              onClick={(e) => e.stopPropagation()} // 👈 prevent close on image click
            />
          )}
        </div>
      )}
    </>
  );
}
